import { render } from "./OptionsItem.vue?vue&type=template&id=b4d7457a"
import script from "./OptionsItem.vue?vue&type=script&lang=js"
export * from "./OptionsItem.vue?vue&type=script&lang=js"

import exportComponent from "/trc/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__